import { useGetFeatureEnabledForCountry } from './useGetFeatureEnabledForCountry';

export default function useIsCustomPlainSQEnabled(): boolean {
  const { isVIPMembershipEnabled } = useGetFeatureEnabledForCountry();
  return isVIPMembershipEnabled;
}
